export default {
    /** 弹出层z-index层级 */
    zIndex: 1799,
    /** 不显示弹出层过渡动画 */
    disTransition: false,
    /** 弹出层背景色 */
    background: "rgba(0,0,0,.55)",
    /** 弹出层transition过渡名称 */
    transition: "fade",
    /** 距离顶部的距离 */
    top: "0",
    /** 点击弹出层背景区域是否触发隐藏弹出层 */
    closeOnClickOverlay: true,
    /** 弹出层内容是否居中 */
    center: false,
    /** 是否为弹出层内容区域添加伸缩盒类型 */
    flex: false,
    /** 弹出层内容区域内边距 */
    padding: "",
    /** 是否在页面切换时自动关闭 */
    closeOnPopstate: true,
    /** 背景区域触发点击事件监听类型 */
    maskTriggerEvent: "touchstart"
}
